import React, { useEffect, useState, useCallback } from 'react'
import './UsecaseList.scss'

import TabsBar from '../MainLayout/TabsBar/TabsBar'
import { getUsecases } from '../../services/usecase.service'

import CircularProgress from '@mui/material/CircularProgress'
import { DataGrid } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

function UsecaseList() {
    const columns = [
        { field: 'id', headerName: 'Id', width: 50 },
        { field: 'name', headerName: 'Name', width: 500 },
        { field: 'lastRun', headerName: 'Last Run', width: 250 },
        { field: 'creationDate', headerName: 'Creation Date', width: 250 },
    ]
    const [_usecases, setUsecases] = useState([])
    const [rows, setRows] = useState([])
    const [isLoading, setLoading] = useState(true)
    const [isErrorPresent, setError] = useState(false)

    interface UsecaseLog {
        id: number
        name: string
        lastRun: string
        creationDate: string
    }

    useEffect(() => {
        const getItems = async () => {
            try {
                const result = await getUsecases()
                let temp_rows: UsecaseLog[] = []

                function createData(id: number, name: string, lastRun: string, creationDate: string): UsecaseLog {
                    return { id, name, lastRun, creationDate }
                }

                result.data.usecases.map((item: any) => {
                    temp_rows.push(createData(item.id, item.name, '-', moment(item.created_date * 1000).format('YYYY-MM-DD HH:mm')))
                })

                // @ts-ignore 2025-05-23 Note ST - Should be OK...?
                setRows(temp_rows)
                setUsecases(result.data.usecases)
                setLoading(false)
            } catch (error) {
                setError(true)
                setLoading(false)
            }
        }

        getItems()
    }, [])

    const navigate = useNavigate()
    const handleOnCellClick = useCallback((params) => navigate('/tactical', { state: { id: params.id } }), [])

    return isLoading ? (
        <div className="UsecaseList" data-test-id="usecase-list">
            <TabsBar />
            <div className="SpinnerContainer" data-test-id="usecase-spinner">
                <CircularProgress />
            </div>
        </div>
    ) : isErrorPresent ? (
        <div className="UsecaseList" data-test-id="usecase-list">
            <TabsBar />
            <div className="ErrorContainer" data-test-id="error-container">
                <span className="ErrorText" data-test-id="error-text">
                    🦫 Error getting the usecases, check if API-Usecase is running! 🪵
                </span>
            </div>
        </div>
    ) : (
        <div className="UsecaseList" data-test-id="usecase-list">
            <TabsBar />
            <div className="UsecaseDataGrid" data-test-id="usecase-datagrid">
                <DataGrid
                    sx={{
                        minWidth: '100vw',
                        minHeight: '70vh',
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#E6E7F4',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                        },
                    }}
                    rows={rows}
                    columns={columns}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    onCellClick={handleOnCellClick}
                />
            </div>
        </div>
    )
}

export default UsecaseList
